// src/Data/ROLES.js
import axios from "axios";

let ROLE_MAP = {}; // initially empty

// 🔹 Fetch roles dynamically from API
export const fetchRoles = async () => {
  try {
    const response = await axios.get("https://spillas.com/api/v1/org_user/roles");
    const data = Array.isArray(response.data)
      ? response.data
      : response.data?.data || [];

    ROLE_MAP = data.reduce((acc, role) => {
      acc[role.id] = role.name;
      return acc;
    }, {});

    console.log("✅ Roles loaded:", ROLE_MAP);
    return ROLE_MAP;
  } catch (error) {
    console.error("❌ Failed to fetch roles:", error);
    return ROLE_MAP;
  }
};

// 🔹 Get role name by ID
export const getRoleName = (id) => ROLE_MAP[id] || "Unknown Role";

// 🔹 Export current map (initially empty until fetchRoles runs)
export { ROLE_MAP };




// // src/Data/ROLES.js
// export const ROLE_MAP = {
//   2: "Company",
//   3: "CNF",
//   4: "Super Stockist",
//   5: "Distributor",
//   6: "Micro Distributor",
//   7: "Retailer",
// };

// // Optional helper
// export const getRoleName = (id) => ROLE_MAP[id] || "Unknown Role";


// ******************************20-10-2025 PHASE 1*************************************************

// export const ROLES = ["Company", "CNF", "Super Stockist", "Distributor", "Micro Distributor"];